import { useState, useEffect, FunctionComponent, ReactElement, Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { routesArray, webRoutesArray } from './_base';
import ProtectedRoute from './ProtectedRoute';
import { Navigate } from './constants';
import { reactPagePropsType } from 'src/interfaces/reactPageProps';
import { isWebView } from 'src/utils/generic';
import LoaderPageV2 from 'src/components/LoaderPageV2';

export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    const checkIsMobile = () => {
      if (typeof window === 'undefined') return false;

      const isNarrow = window.innerWidth < 768;

      const hasTouch = navigator.maxTouchPoints > 0 || 'ontouchstart' in window;

      const isMobileUA = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent);

      return isNarrow || (hasTouch && isMobileUA);
    };

    setIsMobile(checkIsMobile());

    let timeoutId: ReturnType<typeof setTimeout>;
    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => setIsMobile(checkIsMobile()), 150);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isMobile;
};

const Routes = (): ReactElement => {
  type propTypes = {
    path: string;
    Component: FunctionComponent<reactPagePropsType>;
    exact?: boolean;
    isProtected?: boolean;
  };

  const isMobile = useIsMobile();
  const activeRoutes = isMobile ? routesArray : webRoutesArray;

  return (
    <>
      <Suspense fallback={isWebView ? <></> : <LoaderPageV2 />}>
        <Switch>
          {activeRoutes?.map(
            ({ path, Component, exact = true, isProtected }: propTypes, index: number) =>
              isProtected ? (
                <ProtectedRoute path={path} key={index} component={Component} exact={exact} />
              ) : (
                <Route path={path} key={index} component={Component} exact={exact} />
              )
          )}

          <Route path="/">
            <Redirect to={Navigate.login} />
          </Route>
        </Switch>
      </Suspense>
    </>
  );
};

export default Routes;
